<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					imageSrc: {
						name: 'imageSrc',
						defaultValue: '',
						labelDesc: 'imageSrc',
						canRemove: false,
						callback: null,
					},
					width: {
						name: 'width',
						defaultValue: '150',
						min: '50',
						max: '800',
						labelDesc: 'width',
						callback: function () {
							vm.resources.width.defaultValue = this.value;
							vm.element.internal_config.width = this.value + 'px';
						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						},
					},
					height: {
						name: 'height',
						defaultValue: '150',
						min: '50',
						max: '800',
						labelDesc: 'height',
						callback: function () {
							vm.resources.height.defaultValue = this.value;
							vm.element.internal_config.height = this.value + 'px';
						},
					},
					opacity: {
						name: 'opacity',
						defaultValue: '100',
						min: '0',
						max: '100',
						labelDesc: 'opacity',
						callback: function () {

							vm.resources.opacity.defaultValue = this.value;
							vm.element.internal_config.opacity = this.value / 100;

						},
					},
					boxShadow: {
						name: 'boxShadow',
						defaultValue: '0 0 0 0 black initial',
						min: '0',
						max: '50',
						labelDesc: 'boxShadow',
						callback: function () {

							let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

							vm.resources.boxShadow.defaultValue = value;
							vm.element.internal_config.boxShadow = value;
						},
					},
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.borderRadius = value;
						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '50',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},
					margin: {
						name: 'margin',
						defaultLeft: '15',
						defaultRight: '15',
						min: '0',
						max: '50',
						labelDesc: 'margin',
						callback: function () {
							vm.resources.margin.defaultLeft = this.l;
							vm.element.internal_config.marginLeft = this.l + 'px';

							vm.resources.margin.defaultRight = this.r;
							vm.element.internal_config.marginRight = this.r + 'px';

						},
					},
				}
			}
		},
		methods: {
			setValuesData(data) {
				this.element = data;
				this.resources.width.defaultValue = parseInt(data.internal_config.width);
				this.resources.height.defaultValue = parseInt(data.internal_config.height);
				this.resources.opacity.defaultValue = data.internal_config.opacity * 100;
				this.resources.imageSrc.defaultValue = data.internal_config.src;

				this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;
				this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
				this.resources.border.defaultValue = data.internal_config.border;

				this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
				this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
				this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
				this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

				this.resources.margin.defaultLeft = parseInt(data.internal_config.marginLeft);
				this.resources.margin.defaultRight = parseInt(data.internal_config.marginRight);
			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>
